// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__2LgLO","title":"Heading_title__2t28v","description":"Heading_description__3wKDX"};